// test1925
(1925 && 0);
